/**
 * The kinds of speaking_task (ADR-0012). Each is scored differently and counts differently towards the level:
 * - interview_answer: a mock question; unscripted, reviewed for STAR.
 * - free_speech: talk freely for 30-60 s ("tell me about yourself"); unscripted, no STAR. The purest fluency, grammar
 *   and vocabulary sample.
 * - read_aloud: an exact script; scored against it, so it feeds pronunciation and sounds only.
 */
export const TASK_KINDS = ['interview_answer', 'free_speech', 'read_aloud'] as const;
export type TaskKind = (typeof TASK_KINDS)[number];
